<template>
  <ts-modal
    ref="modal"
    modal-title="Edit columns"
  >
    <template #modal-content>
      <div class="card">
        <div
          v-if="columns.length == 0"
          class="card-body text-muted"
        >
          No columns defined
        </div>
        <sortable
          :list="columns"
          item-key="id"
          :options="{draggable: '.list-group-item', handle: '.sort-handle', animation: 150}"
          class="list-group list-group-flush"
          @end="updateColumnOrder"
        >
          <template #item="{element: column}">
            <div class="list-group-item">
              <div class="row gx-2">
                <div class="col-auto">
                  <span
                    class="glyphicons sortable sort-handle"
                    title="Drag to reorder items"
                  />
                </div>
                <div class="col">
                  <input
                    v-model="column.title"
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="Title"
                  >
                </div>
                <div class="col-auto">
                  <button
                    type="button"
                    class="btn btn-sm btn-danger"
                    @click.prevent="deleteColumn(column)"
                  >
                    <span
                      class="glyphicons delete"
                      title="Delete column"
                    />
                  </button>
                </div>
              </div>
            </div>
          </template>
        </sortable>
        <div class="card-footer">
          <button
            type="button"
            class="btn btn-sm btn-success"
            @click.prevent="addColumn"
          >
            Add column
          </button>
        </div>
      </div>
    </template>
    <template #modal-footer>
      <button
        type="button"
        class="btn btn-sm btn-secondary"
        data-bs-dismiss="modal"
      >
        Close
      </button>
      <button
        type="button"
        class="btn btn-sm btn-primary"
        @click="saveColumns"
      >
        Ok
      </button>
    </template>
  </ts-modal>
</template>
<script setup lang="ts">
  import {ref, useTemplateRef} from "vue"
  import type {SortableEvent} from "sortablejs"
  import {Sortable} from "sortablejs-vue3"
  import {sortSortableList} from "@/js/js-utils"
  import TsModal from "@/js/vue-components/ts-modal.vue"
  import type {SurveyReportColumn} from "./survey-types"

  const emit = defineEmits<{
    save: [columns: SurveyReportColumn[]]
  }>()

  const modal = useTemplateRef<InstanceType<typeof TsModal>>("modal")

  const columns = ref<SurveyReportColumn[]>([])

  const showModal = (columnList: SurveyReportColumn[]): void => {
    columns.value = JSON.parse(JSON.stringify(columnList)) as SurveyReportColumn[]
    modal.value?.show()
  }

  const hideModal = (): void => {
    modal.value?.hide()
  }

  const deleteColumn = (column: SurveyReportColumn): void => {
    if (confirm("Are you sure?")) {
      for (let i = 0; i < columns.value.length; i++) {
        if (columns.value[i].id === column.id) {
          columns.value.splice(i, 1)
          break
        }
      }
    }
  }

  const addColumn = (): void => {
    const newId = `c${ new Date().getTime() }`
    columns.value.push({
      id: newId,
      title: "",
    })
  }

  const saveColumns = (): void => {
    emit("save", columns.value)
  }

  const updateColumnOrder = (event: SortableEvent): void => {
    sortSortableList(columns.value, event)
  }

  defineExpose({
    hideModal,
    showModal,
  })
</script>
